import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const useAuthCon = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('access_token');
        if (!token) {
            // Si le token n'est pas présent, rediriger vers la page de connexion
            console.log('token absent')
            navigate('/', { replace: true });
        } else {
            navigate('/papachigan', { replace: true });
        }
    }, [navigate]);
};

export default useAuthCon;
